import { DataTableColumns } from '../../model/interfaces/data-table-columns.interface';

export type AnalyticsColumnProp =
  | 'outcome'
  | 'average'
  | 'probability'
  | 'historical'
  | 'bear'
  | 'neutral'
  | 'bull'
  | 'last5'
  | 'last10'
  | 'last15'
  | 'increase'
  | 'decrease'
  | 'exitAfterIHP'
  | 'exitAfterRHP'
  | 'metricDescription'
  | 'metricValue';

export type AnalyticsColumnData = {
  name: string;
  prop: string;
  resizeable: boolean;
  draggable: boolean;
  canAutoResize: boolean;
  flexGrow: number;
  cellTemplate: string;
};

export const BackTestingDataColumns = [
  {
    name: 'Scenario',
    prop: 'outcome',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Avg. Return (%)',
    prop: 'average',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Probability (%)',
    prop: 'probability',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
];

export const ForwardTestingDataColumns = [
  {
    name: 'Scenario',
    prop: 'outcome',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Avg. Return (%)',
    prop: 'average',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Probability (%)',
    prop: 'probability',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
];

export const ProbabilityOfReturnsColumns = [
  {
    name: 'Outcome',
    prop: 'outcome',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Historical',
    prop: 'historical',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Bear (More Volatile)',
    prop: 'bear',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Neutral',
    prop: 'neutral',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Bull (Less Volatile)',
    prop: 'bull',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Rate Decrease',
    prop: 'decrease',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Rate Increase',
    prop: 'increase',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
];

export const BacktestedProbabilityOfLossColumns = [
  {
    name: 'Outcome',
    prop: 'outcome',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Last 5 Years',
    prop: 'last5',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Last 10 Years',
    prop: 'last10',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Last 15 Years',
    prop: 'last15',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
];

export const ForwardLookingProbabilityOfLossColumns = [
  {
    name: 'Outcome',
    prop: 'outcome',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Bear (More Volatile)',
    prop: 'bear',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Neutral',
    prop: 'neutral',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Bull (Less Volatile)',
    prop: 'bull',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Rate Decrease',
    prop: 'decrease',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Rate Increase',
    prop: 'increase',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
];

export const RiskRewardColumns = [
  {
    name: 'Outcome',
    prop: 'outcome',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Bear (More Volatile)',
    prop: 'bear',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Neutral',
    prop: 'neutral',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Bull (Less Volatile)',
    prop: 'bull',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Rate Increase',
    prop: 'increase',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Rate Decrease',
    prop: 'decrease',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Average Of All Scenarios',
    prop: 'average',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
];

export const ValueForMoneyFVCColumns = [
  {
    name: 'Outcome',
    prop: 'outcome',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Bear (More Volatile)',
    prop: 'bear',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Neutral',
    prop: 'neutral',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Bull (Less Volatile)',
    prop: 'bull',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Rate Decrease',
    prop: 'decrease',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
  {
    name: 'Rate Increase',
    prop: 'increase',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
];

export const ProbabilityOfLossColumns: DataTableColumns[] = [
  {
    name: 'Outcome',
    prop: 'outcome',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Probability (%)',
    prop: 'probability',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellClass: 'text-right',
    headerClass: 'text-right',
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
];

export const ValueForMoneyCloudRiskColumns = [
  {
    name: 'Outcome',
    prop: 'outcome',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Probability (%)',
    prop: 'probability',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellClass: 'text-right',
    headerClass: 'text-right',
    cellTemplate: 'numberToTwoDecimalPlacesTemplate',
  },
];

export const PRIIPsSummaryColumns: DataTableColumns[] = [
  {
    name: '',
    prop: 'metricDescription',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: '',
    prop: 'metricValue',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 0.5,
    cellClass: 'text-right',
    headerClass: 'text-right',
    cellTemplate: 'valueOrDashTemplate',
  },
];

export const PRIIPsReturnScenariosColumns = [
  {
    name: '',
    prop: 'testDescription',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: '',
    prop: 'metricDescription',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Exit after IHP',
    prop: 'exitAfterIHP',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellClass: 'text-right',
    headerClass: 'text-right',
    cellTemplate: 'valueOrDashTemplate',
  },
  {
    name: 'Exit after RHP',
    prop: 'exitAfterRHP',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellClass: 'text-right',
    headerClass: 'text-right',
    cellTemplate: 'valueOrDashTemplate',
  },
];

export const PRIIPsCostsColumns = [
  {
    name: '',
    prop: 'metricDescription',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'valueOrDashWithUpperCaseFirstLetterTemplate',
  },
  {
    name: 'Exit after IHP',
    prop: 'exitAfterIHP',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellClass: 'text-right',
    headerClass: 'text-right',
    cellTemplate: 'valueOrDashTemplate',
  },
  {
    name: 'Exit after RHP',
    prop: 'exitAfterRHP',
    resizeable: false,
    draggable: false,
    canAutoResize: true,
    flexGrow: 1,
    cellClass: 'text-right',
    headerClass: 'text-right',
    cellTemplate: 'valueOrDashTemplate',
  },
];
